import { getStoredGame, getSystemInfo } from '../services/resources.service';

const LOAD = 'loadStoredGames';
const LOAD_SYSTEM_INFO = 'loadSystemInfo';
const SET = 'set';
const SET_SYSTEM_INFO = 'setSystemInfo';

const state = {
    games: [],
    systemInfo: []
};

const getters = {
    state: state => state,
};

const actions = {
    [LOAD]: async ({ commit }) => {
        const games = await getStoredGame();
        commit(SET, { games });
    },

    [LOAD_SYSTEM_INFO]: async ({ commit }) => {
        const info = await getSystemInfo();
        commit(SET_SYSTEM_INFO, { info });
    },
};

const mutations = {
    [SET](state, { games }) {
        state.games = games;
    },
    [SET_SYSTEM_INFO](state, { info }) {
        state.systemInfo = info;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./skins/xkiosk/data/local-resources.js